
import React from 'react';

const SlidersIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0h-3m-3 0H2.25m4.5 0a1.5 1.5 0 1 1-3 0M13.5 10.5H21.75m-8.25 0a1.5 1.5 0 1 1-3 0m3 0h-3m-3 0H2.25m4.5 0a1.5 1.5 0 1 1-3 0m3 0h-3m-3 0h-9.75" />
  </svg>
);

export default SlidersIcon;
